import { inject } from '@angular/core';

import { Router, CanActivateFn } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

export const SessionGuard: CanActivateFn = async () => {
    const msalService = inject(MsalService);
    const router = inject(Router);

    const activeAccount = await msalService.instance.getActiveAccount();
          
    if (!activeAccount) {
      return router.createUrlTree(['/login']);
    }

    return true;
};